var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2528_2222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18494 9.031V5.00445C7.61438 5.67707 8.72147 6.32683 10.0308 7.02736C8.95089 7.62628 7.61438 8.29828 6.18494 9.031ZM14.1512 3.00185C13.9046 2.67699 13.4844 2.42412 13.037 2.3404C11.7219 2.09067 3.51762 2.08996 2.20325 2.3404C1.84446 2.40766 1.52497 2.57023 1.25052 2.82283C0.0941079 3.89616 0.456473 9.65208 0.735214 10.5845C0.852427 10.988 1.00395 11.2791 1.19478 11.4701C1.44065 11.7227 1.77727 11.8966 2.16394 11.9746C3.24673 12.1986 8.82511 12.3238 13.0141 12.0083C13.4 11.941 13.7416 11.7615 14.0111 11.4982C15.0803 10.4291 15.0074 4.34996 14.1512 3.00185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2528_2222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3503,
    height: 14.3503,
    fill: "white",
    transform: "translate(0.449219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.236f447846865b37d66099b2cd60e66d.svg";
export { ForwardRef as ReactComponent };